import React, { useState } from 'react';
import {Button, Icon, Table, Header, Popup, Loader, Segment, Grid} from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';

import { IconHeader, FiltersOnStyle, HeaderCursor } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import PaginationFront from '../../util/PaginationFront';
import {ExportReactCSV} from "../../util/ExportCSV";
import SearchTableData from "../../util/SearchTableData";
import ReactExport from 'react-data-export';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema studenata.</p>;
const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema studenata.</p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class PreviousSemesterStudents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filterData: [],
            studyPrograms: [],
            student: null,

            showFiltersOnButton: false,
            showFilterMode: false,
            loading: false,
            showStudentInfo: false,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: [],
            excelData: []


        };


        this.filtersOff = this.filtersOff.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.activateFilter = this.activateFilter.bind(this);
        this.getStudyPrograms = this.getStudyPrograms.bind(this);
        this.getStudentsBySP = this.getStudentsBySP.bind(this);
        this.getResults = this.getResults.bind(this);

    }

    componentDidMount() {
        this.getStudyPrograms();
        this.getStudentsBySP();
    }


    getStudentsBySP() {
        this.setState({ loading: true });
        let obj = {};
        axios.post('/students/enrolled-in-previous-not-in-current-semester', { ...obj })
            .then(res => {
                this.setState({
                    data: res.data.map(el=>({...el, department: el.departmentsSPOU.length  ? el.departmentsSPOU[0].organizationalUnitName : ''})),
                    loading: false
                });
                const excelData = res.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.index},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.studyCycleName}
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                console.log('Failed to fetch students.');
            });
    }

    getStudyPrograms() {
        axios.get('study-programs/by-organizational-unit')
            .then(res => {
                const studyPrograms = res.data.filter(el => el.studyProgram.studyProgramStatus._key !== 'archived').map(el => ({
                    value: el.studyProgram.id, text: el.studyProgram.studyProgramBasic.name + ' - ' + el.studyProgram.name, key: el.studyProgram.id, description: el.studyCycles[0].name
                }));
                this.setState({ studyPrograms});
            })
            .catch(err => {
                console.log('Failed to fetch study programs');
            });
    }


    getDataToRender() {
        if (this.state.showFiltersOnButton  && this.state.results.length === 0) {
            return this.state.filterData;
        }
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    getFilterData(firstName, lastName, index, studyProgramId) {
        this.setState({ loading: true });
        let docFilter = {};

        if (studyProgramId) docFilter = { ...docFilter, studyProgramId };
        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (index) docFilter = { ...docFilter, index };

        axios.post('/students/enrolled-in-previous-not-in-current-semester', { ...docFilter })
            .then(res => {
                const filterData = res.data.sort((a, b) => b.firstName < a.firstName);
                this.setState({
                    filterData, loading: false, showFiltersOnButton: true, showFilterMode: false
                });
                const excelData = res.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.index},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.studyCycleName}
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch filter results');
                toast('Došlo je do greške! Filtriranje nije uspjelo.');
            });
    }

    filtersOff() {
        const excelData = this.state.data.map(el => ([
            { value: el.lastName},
            { value: el.firstName},
            { value: el.index},
            { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
            { value: el.studyProgramBasicName},
            { value: el.studyProgramName},
            { value: el.studyCycleName}
        ]));
        this.setState({excelData: excelData});
        this.setState({
            showFilterMode: false, showFiltersOnButton: false, loading: false
        });
        return this.state.data;
    }
    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }
    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        // const headersForExport = [
        //     { label: 'Prezime', key: 'lastName' },
        //     { label: 'Ime', key: 'firstName' },
        //     { label: 'Index', key: 'index' },
        //     { label: 'Odsjek', key: 'departmentsSPOU[0].organizationalUnitName' },
        //     // { label: 'Odsjek', key: 'studyProgramBasicName' },
        //     { label: 'Studijski program', key: 'studyProgramBasicName' },
        //     { label: 'Plan i program', key: 'studyProgramName' },
        //     { label: 'Ciklus studija', key: 'studyCycleName' },
        // ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 200 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'Plan i program', width: { wpx: 300 } },
                    { title: 'Ciklus studija', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        // Change page


        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /><br /></div>;
        if (this.state.showStudentInfo === true) {
            return <Redirect push to={{ pathname: '/spisak-studenata/informacije-o-studentu', state: { student: this.state.student } }} />;
        }
        return (
            <div>
                <Header style={IconHeader} floated="right" >
                    {this.state.showFiltersOnButton && <Button
                        onClick={this.filtersOff}
                        floated="left"
                        icon
                        labelPosition="right"
                        color="orange"
                        size="small"
                        style={FiltersOnStyle}
                    ><Icon className="remove" onClick={this.filtersOff} />
                        Filtriranje uključeno!
                    </Button>}
                    {this.getDataToRender().length ? <Popup
                        trigger={<Icon
                            link
                            circular
                            basic
                            floated="right"
                            name="filter"
                            onClick={() => { this.setState({ showFilterMode: !this.state.showFilterMode }); }}
                        />}
                        content="Filtriraj podatke"

                        hideOnScroll
                        position="top center"
                    />
                        : null}
                </Header>
                <br />

                {this.state.showFilterMode && <Segment secondary clearing> <Filters
                    onFilterData={this.getFilterData}
                    studyPrograms={this.state.studyPrograms}
                    filtersOff={this.filtersOff}
                    sp
                /></Segment>
                }
                {this.state.loading && <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /><br /></div>}
                {(currentPosts.length && !this.state.loading) ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={15} >
                                    <Grid columns={2} stackable>

                                        <Grid.Column width={14}>
                                            <SearchTableData profMozilla data={this.state.showFiltersOnButton ? this.state.filterData : this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'studyProgramName', 'studyProgramBasicName', 'department', 'studyCycleName']} />
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign={'center'}>
                                            <ExcelFile filename="Spisak studenata koji nisu upisani u trenutni semestar" element={<Popup
                                                trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                    <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                    <Button.Content visible>
                                                        Excel
                                                    </Button.Content>
                                                </Button>}
                                                content="Preuzmi spisak u Excel-u"
                                                hideOnScroll
                                                position="top center"
                                            />}>
                                                <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                            </ExcelFile>
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                                {/*<Table.HeaderCell colSpan={15} >*/}
                                {/*        <span> {this.state.data && <ExportReactCSV color="green" csvData={this.state.data} headers={headersForExport} floated="right" fileName="Spisak neupisanih studenata" />}*/}
                                {/*            <SearchTableData data={this.state.showFiltersOnButton ? this.state.filterData : this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'studyProgramName', 'studyProgramBasicName', 'department', 'studyCycleName']} />*/}
                                {/*        </span>*/}
                                {/*</Table.HeaderCell>*/}
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Prezime i ime</Table.HeaderCell>
                                {/*<Table.HeaderCell colSpan={2}>Ime</Table.HeaderCell>*/}
                                <Table.HeaderCell colSpan={2}>Broj indexa</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Odsjek</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Studijski program</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Ciklus studija</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {currentPosts.map((el, index) =>
                            (<Popup
                                trigger={<Table.Row
                                    key={index}
                                    style={HeaderCursor}
                                    onClick={() => {
                                        this.setState({ student: el, showStudentInfo: true });
                                        localStorage.setItem('student', JSON.stringify(el));
                                    }}
                                >
                                    <Table.Cell verticalAlign="middle">
                                        {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                    </Table.Cell >
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {el.lastName} {el.firstName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.index}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {el.departmentsSPOU.map(e => <div>{e.organizationalUnitName} <br /></div>)}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {el.studyCycleName}
                                    </Table.Cell>
                                </Table.Row>}
                                content="Prikaz informacija o studentu"
                                hideOnScroll
                                position="left center"
                            />))}
                        </Table.Body>
                    </Table>
                    : this.state.showFiltersOnButton ?
                        <NoFilterDataMessage />
                        : <NoDataMessage />
                }
                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/PreviousSemesterStudents.js